import { useState } from "react";
import ChatBubble from "../../components/ChatBubble";
import ConversationListItem from "../../components/ConversationListItem";
import ResidentSelectItem from "../../components/ResidentSelectItem";
import SenderChatBubble from "../../components/SenderChatBubble";
import { DUMMY_CONVERSATIONS } from "../../data/dummy_converation_list";
import { DUMMY_MESSAGES } from "../../data/dummy_messages";
import { DUMMY_RESIDENTS } from "../../data/dummy_residents";
import { useInbox } from "../../features/chat";

const Home = () => {
  const [selectedId, setSelectedId] = useState<string>("2");
  const [selectedResidents, setSelectedResidents] = useState<string[]>([]);

  const { data: inboxItems, isLoading: inboxLoading, error: inboxError } = useInbox({
    archived: false,
    filter: { userTypeMessages: "aboutpatient", searchKeyword: "" },
    roleId: 1,
    page: 1,
  }, true);

  console.log("[Inbox] loading:", inboxLoading, "| items:", inboxItems?.length, "| error:", inboxError);

  const selectedConversation = DUMMY_CONVERSATIONS.find((c) => c.id === selectedId);
  const messages = selectedId ? DUMMY_MESSAGES[selectedId] ?? [] : [];

  const toggleResident = (id: string) => {
    setSelectedResidents((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  return (
    <div className="lds-flex lds-flex-col lds-h-screen lds-bg-surface-weak">

      {/* ── Top 60% — Conversation list + Chat window ── */}
      <div className="lds-flex lds-h-[60%] lds-min-h-0 lds-border-b lds-border-bordercolor-default">

        {/* Conversation list */}
        <div className="lds-w-80 lds-shrink-0 lds-border-r lds-border-bordercolor-default lds-bg-white lds-overflow-y-auto">
          {DUMMY_CONVERSATIONS.map((conversation) => (
            <ConversationListItem
              key={conversation.id}
              name={conversation.name}
              subtitle={conversation.subtitle}
              time={conversation.time}
              showExternal={conversation.showExternal}
              avatarLabel={conversation.avatarLabel}
              isSelected={selectedId === conversation.id}
              onClick={() => setSelectedId(conversation.id)}
            />
          ))}
        </div>

        {/* Chat window */}
        <div className="lds-flex-1 lds-flex lds-flex-col lds-min-w-0">
          {selectedConversation ? (
            <>
              {/* Chat header */}
              <div className="lds-px-6 lds-py-4 lds-border-b lds-border-bordercolor-default lds-bg-white">
                <p className="lds-text-sm lds-font-bold lds-leading-[125%] lds-text-textcolor-default">
                  {selectedConversation.name}
                </p>
                <p className="lds-text-xs lds-font-normal lds-leading-[125%] lds-text-textcolor-caption lds-mt-0.5">
                  {selectedConversation.subtitle}
                </p>
              </div>

              {/* Messages */}
              <div className="lds-flex-1 lds-overflow-y-auto lds-px-6 lds-py-4 lds-flex lds-flex-col lds-gap-4 lds-bg-white">
                {messages.map((message) =>
                  message.type === "received" ? (
                    <ChatBubble
                      key={message.id}
                      id={message.id}
                      userName={message.userName ?? ""}
                      avatarLabel={message.avatarLabel}
                      content={message.content}
                      timestamp={message.timestamp}
                    />
                  ) : (
                    <SenderChatBubble
                      key={message.id}
                      id={message.id}
                      content={message.content}
                      timestamp={message.timestamp}
                      status={message.status ?? "sent"}
                    />
                  )
                )}
              </div>
            </>
          ) : (
            <div className="lds-flex-1 lds-flex lds-items-center lds-justify-center lds-bg-white">
              <p className="lds-text-sm lds-text-textcolor-caption">
                Select a conversation to view messages
              </p>
            </div>
          )}
        </div>
      </div>

      {/* ── Bottom 40% — Resident select panel ── */}
      <div className="lds-flex lds-flex-col lds-h-[40%] lds-min-h-0 lds-bg-white">
        <div className="lds-px-6 lds-py-4 lds-border-b lds-border-bordercolor-default lds-shrink-0">
          <p className="lds-text-sm lds-font-bold lds-leading-[125%] lds-text-textcolor-default">
            Select Residents
          </p>
          <p className="lds-text-xs lds-font-normal lds-leading-[125%] lds-text-textcolor-caption lds-mt-0.5">
            {selectedResidents.length} selected
          </p>
        </div>
        <div className="lds-flex lds-flex-row lds-flex-wrap lds-gap-3 lds-p-4 lds-overflow-y-auto">
          {DUMMY_RESIDENTS.map((resident) => (
            <ResidentSelectItem
              key={resident.id}
              name={resident.name}
              room={resident.room}
              mrn={resident.mrn}
              status={resident.status}
              avatarLabel={resident.avatarLabel}
              isSelected={selectedResidents.includes(resident.id)}
              onClick={() => toggleResident(resident.id)}
            />
          ))}
        </div>
      </div>

    </div>
  );
};

export default Home;
